import request from '@/utils/request'
// 问题保修列表
export function PblmWarrantyList(data) {
    return request({
        url:'/netbar/api/maintenance_form/v1/list',
        method:'post',
        data
    })
}
// 保修单列表详情
export function PblmWarrantyDetail(data) {
    return request({
        url:'/netbar/api/maintenance_form/v1/list_detail',
        method:'post',
        data
    })
}
// 获取地址网吧
export function PblmWarrantyInfo(data) {
    return request({
        url:'/netbar/api/user/v1/belong_netbar',
        method:'post',
        data
    })
}
// 填写保修单类型 
export function PblmWarrantyType(data) {
    return request({
        url:'/netbar/api/maintenance_type/v1/list',
        method:'post',
        data
    })
}
// 填写保修单
export function PblmWarrantySave(data) {
    return request({
        url:'/netbar/api/maintenance_form/v1/save',
        method:'post',
        data
    })
}

